import React, { useState, useEffect } from "react";
import arrow from "../../assets/SVG.svg";
import logo from "../../assets/agent-sre-logo.svg";
import "./header.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const scrollToSection = (id) => {
    const headerHeight = document.querySelector(".header-section")?.offsetHeight + 60;
    const section = document.getElementById(id);
    if (section) {
      const sectionPosition = section.offsetTop - headerHeight;
      window.scrollTo({ top: sectionPosition, behavior: "smooth" });
    }
    setMenuOpen(false);
  };

    useEffect(() => {
    const sections = document.querySelectorAll("section[id]");
    const headerHeight = document.querySelector(".header-section")?.offsetHeight || 120;

    const handleScroll = () => {
      let current = "";
      sections.forEach((section) => {
        const sectionTop = section.offsetTop - headerHeight - 10; // small buffer
        if (window.scrollY >= sectionTop) {
          current = section.getAttribute("id");
        }
      });
      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="header-section">
      <div className="container">
        <div className="header-wrapper">
          <div className="header-image">
            <a href="/">
              <img src={logo} alt="agent-sre-logo" />
            </a>
          </div>

          <nav className={`header-items ${menuOpen ? "active" : ""}`}>
            <ul>
              <li>
                <a
                  href="#platform"
                  className={activeSection === "platform" ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("platform");
                  }}
                >
                  Key Benefits
                </a>
              </li>
                <li>
                <a
                  href="#usecases"
                  className={activeSection === "usecases" ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("usecases");
                  }}
                >
                  Use Cases
                </a>
              </li>
              <li>
                <a
                  href="#agents"
                  className={activeSection === "agents" ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("agents");
                  }}
                >
                  AI Agents
                </a>
              </li>
              <li>
                <a
                  href="#solutions"
                  className={activeSection === "solutions" ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("solutions");
                  }}
                >
                  Solutions
                </a>
              </li>
                 <li>
                <a
                  href="#faq"
                  className={activeSection === "faq" ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("faq");
                  }}
                >
                  FAQ
                </a>
              </li>
            </ul>
          </nav>

          <a href="https://demo.akira.ai/agentsre" className="book-demo">
            <div className="book-demo-btn">
              <p>Book Demo</p>
              <img src={arrow} alt="arrow-icon" />
            </div>
          </a>

          <div
            className={`hamburger ${menuOpen ? "active" : ""}`}
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
